export default (token: string) => {
  return {
    timeout: 5000,
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json"
    }
  };
};
